import { render, staticRenderFns } from "./ns-order-details.vue?vue&type=template&id=61125ae6&"
import script from "./ns-order-details.vue?vue&type=script&lang=js&"
export * from "./ns-order-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports